import React from 'react';
export function HeroSection() {
  return <section className="relative w-full flex flex-col text-center items-center justify-center px-5 pt-12 pb-10 sm:pt-24 sm:pb-16 overflow-hidden" style={{
    background: 'radial-gradient(ellipse at 50% 30%, #FFF1E6 0%, #FFF8F0 60%)'
  }} data-id="element-105">
      {/* Ambient glow */}
      <div className="absolute top-[20%] left-1/2 -translate-x-1/2 w-[700px] h-[400px] rounded-full pointer-events-none opacity-60" style={{
      background: 'radial-gradient(ellipse, rgba(245,200,75,0.15) 0%, transparent 70%)'
    }} data-id="element-106" />

      {/* Brand */}
      <p className="relative text-[#F5A04B] text-sm sm:text-base font-bold tracking-[0.3em] uppercase mb-5 sm:mb-8" data-id="element-107">
        💛 ITERAPRO™
      </p>

      {/* Headline */}
      <h1 className="relative font-black text-[#3D3935] max-w-3xl text-[1.75rem] sm:text-4xl md:text-[3.5rem] leading-[1.1] mb-5 sm:mb-7 uppercase" data-id="element-108">
        Dejá de pasar horas buscando actividades para niños con{' '}
        <span className="text-[#F5A04B]" data-id="element-109">TEA, TDAH y Dislexia</span>
      </h1>

      {/* Tagline pills */}
      <div className="flex flex-col items-center gap-3 sm:gap-4 mb-5 sm:mb-8 max-w-lg" data-id="element-110">
        <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-2 sm:gap-x-3" data-id="element-111">
          {['Atención', 'Lectoescritura', 'Emociones', 'Lenguaje', 'Matemática', 'Habilidades sociales'].map((item, i) => <span key={i} className="text-[#8B7E76] text-xs sm:text-sm font-bold bg-white border border-[#EFE3D4] px-3 sm:px-3.5 py-1.5 sm:py-1.5 rounded-lg shadow-sm" data-id="element-112">
              {item}
            </span>)}
        </div>
        <p className="text-[#3D3935] font-extrabold text-base sm:text-lg tracking-wide" data-id="element-113">
          ⚡ Todo ya listo para imprimir, aplicar y trabajar desde hoy.
        </p>
      </div>

      {/* Product image */}
      <div className="relative w-full max-w-[280px] sm:max-w-[420px] md:max-w-[480px] mx-auto mb-6 sm:mb-8" data-id="element-114">
        <div className="absolute inset-[-16px] rounded-3xl pointer-events-none" style={{
        background: 'radial-gradient(circle, rgba(245,200,75,0.15) 0%, transparent 60%)'
      }} data-id="element-115" />
        <img src="https://cdn.magicpatterns.com/uploads/7YqTGmJWYqSwQijVphVKVh/hf_20260527_005529_e6542712-7be3-4bf8-9ff5-46927f71c36b-Photoroom.png" alt="MEGA PACK INCLUSIVO INFANTIL" className="relative w-full h-auto object-contain" width={800} height={700} fetchPriority="high" data-id="element-116" />
      </div>

      {/* Feature bar — visible on desktop only */}
      <div className="hidden sm:flex sm:gap-5 sm:mb-9 text-[#8B7E76] text-xs font-bold tracking-wide uppercase flex-row items-center justify-center flex-wrap" data-id="element-117">
        <span className="text-[#3D3935]" data-id="element-118">📄 PDF</span>
        <span className="w-px h-3 bg-[#EFE3D4]" data-id="element-119" />
        <span className="text-[#3D3935]" data-id="element-120">⚡ Inmediato</span>
        <span className="w-px h-3 bg-[#EFE3D4]" data-id="element-121" />
        <span className="text-[#3D3935]" data-id="element-122">🇦🇷 Argentina</span>
        <span className="w-px h-3 bg-[#EFE3D4]" data-id="element-123" />
        <span className="text-[#3D3935]" data-id="element-124">🧠 +500 recursos</span>
        <span className="w-px h-3 bg-[#EFE3D4]" data-id="element-125" />
        <span className="text-[#3D3935]" data-id="element-126">🎁 +98 libros para colorear</span>
      </div>

      {/* CTA */}
      <a href="#pricing" className="btn-brand-pulse relative bg-gradient-to-b from-[#F5C84B] to-[#F5A04B] text-[#3D3935] font-black text-base sm:text-xl py-4 sm:py-5 rounded-2xl flex items-center justify-center gap-1.5 sm:gap-2 mb-4 sm:mb-4 w-full max-w-xl shadow-[0_0_40px_rgba(245,200,75,0.3),0_4px_20px_rgba(0,0,0,0.1)] hover:shadow-[0_0_60px_rgba(245,200,75,0.45),0_0_120px_rgba(245,200,75,0.15)] hover:scale-[1.03] active:scale-[0.97] transition-all duration-200 overflow-hidden group" data-id="element-127">
        {/* Anchor scroll to #pricing section where the real checkout CTA lives */}
        {/* Inner highlight */}
        <span className="absolute inset-0 rounded-2xl border border-white/40 pointer-events-none" data-id="element-128" />
        {/* Top shine */}
        <span className="absolute inset-x-0 top-0 h-[45%] bg-gradient-to-b from-white/30 to-transparent rounded-t-2xl pointer-events-none" data-id="element-129" />
        {/* Hover sweep */}
        <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out pointer-events-none" data-id="element-130" />
        <span className="relative z-10 drop-shadow-[0_1px_1px_rgba(255,255,255,0.5)]" data-id="element-131">
          SÍ, QUIERO EL MEGA PACK AHORA
        </span>
        <span className="relative z-10 inline-flex items-center text-base sm:text-xl leading-none animate-[bounceX_1.2s_ease-in-out_infinite]" data-id="element-132">
          →
        </span>
      </a>

      {/* Social proof micro-line */}
      <p className="text-[#8B7E76] text-xs sm:text-sm mb-3 sm:mb-4 font-medium" data-id="element-133">
        ⚡{' '}
        <span className="text-[#3D3935] font-bold" data-id="element-134">
          +1.000 docentes y familias
        </span>{' '}
        ya lo están usando
      </p>

      {/* Trust */}
      <p className="text-[#8B7E76] text-xs sm:text-sm tracking-wide leading-relaxed font-semibold" data-id="element-135">
        🛡️ Garantía 7 días &nbsp;·&nbsp; 🔒 Pago seguro &nbsp;·&nbsp; 💳 Tarjeta
        · Mercado Pago
      </p>
    </section>;
}